import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';
import { FONT_PROPERTIES } from 'common/components/TouchpointEditor/components/TouchpointContainer';
import * as Tabs from '@radix-ui/react-tabs';

export const StyledDefaultBlockContainer = styled(Block)`
    padding: 4rem;

    ${mediaMaxWidth.large`
        padding: 4rem 1.5rem;
    `}

    ${mediaMaxWidth.medium`
        padding: 2rem 1rem;
    `}
`;

export const StyledSessionsNavigationBlock = styled(Block)`
    padding: 1.5rem 4rem;

    ${mediaMaxWidth.large`
        padding: 1.5rem;
    `}

    ${mediaMaxWidth.medium`
        padding: 2rem 1rem 1rem;
    `}
`;

export const StyledTabsContent = styled(Tabs.Content)`
    width: 100%;
    max-width: 770px;
`;

export const StyledSessionsListBlock = styled(Block)`
    padding: 0.5rem 4rem 4rem;
    flex-direction: column;
    align-items: center;

    ${FONT_PROPERTIES};

    ${mediaMaxWidth.large`
        padding: 1rem 1.5rem 4rem;
    `}

    ${mediaMaxWidth.medium`
        padding: 1.5rem 1rem 4rem;
    `}
`;
